// @flow
import type { PrismicLinkType } from '~schema';

export default function getLMenuType(
  link: ?PrismicLinkType,
) {
  const document = link && link.document;
  return document && document.__typename === 'PrismicMenu'
    ? document
    : undefined;
}
